export default __webpack_public_path__ + "static/media/navbar_logo_tab.c7f54a83.svg";